module.exports = __webpack_public_path__ + "img/bvn-success.a75e7d44.svg";